<!--回放视频间-->
<!--wj-->
<template>
    <div class="LiveBack">
        <el-row :gutter="20" class="deHeader">
            <el-col :span="6" @click.native="backGo()" style="padding-top: 0.5rem;">
                <i class="el-icon-arrow-left de_icon" ></i>
            </el-col>
            <el-col :span="12" style="text-align: center;">
                <div class="compMsg">直播课程</div>
            </el-col>
        </el-row>
        <video-bar></video-bar>
        <div class="live-jj">
            <p class="offline-title"><strong>{{RoomDesc.cName}}</strong></p>
            <div class="live-room">
                <p class="live-jj-p"><img :src="RoomDesc.photo" :onerror="tslogo" class="tstt-logo"></p>
                <div class="live-nickname">
                    <div>{{RoomDesc.nickName}}</div>
                    <div>
                        <img class="live-jjimg" :src="img1">
                        <span class="live-jj-num">{{RoomDesc.flowerNum}}</span>
                        <img class="live-jjimg" :src="img">
                        <span class="live-jj-num">{{RoomDesc.hotNum}}</span>
                    </div>
                </div>
             </div>
        </div>
        <div>
            <p class="offline-jj" style="padding-bottom:1rem;"><strong>课程简介</strong><span class="cStatus">{{RoomDesc.cStatus}}</span></p>
            <div class="offline-detail" style="padding-top:1rem;">
                <p v-html="RoomDesc.desc">{{RoomDesc.desc}}</p>
            </div>
        </div>
        <share-wechat></share-wechat>
    </div>
</template>
<script>
import Axios from "axios";
import VideoBar from "@/components/VideoBar";
import { eventBus } from "@/assets/js/eventBus";
import ShareWechat from "@/components/ShareWechat";
export default {
    data(){
        return{
            cId:'',
            backUrl:'',
            RoomDesc:[],
            tslogo:'this.src="' + require("@/assets/image/tx3.svg") + '"', //专家默认图片
            img:require("@/assets/image/desc-icon-viewers.png"),
            img1:require("@/assets/image/desc-icon-likes.png"),
        }
    },
    components:{
        VideoBar,
        ShareWechat
    },
    mounted(){
        const that= this;
        that.cId = that.$route.query.cId;
        that.backUrl = that.$route.query.backUrl;
        that.getList();
    },
    methods:{
        getList(){
            const that = this;
            if(that.backUrl){
                var data = {
                    url: that.backUrl,
                };
                eventBus.$emit("fileUrl", data);
            }
            Axios.get(that.$store.state.APIURLS + "Room/getBackRoomDesc?cId="+that.cId).then(function(res) {
                if(res.data.code ==200){
                    that.RoomDesc =res.data.data;
                    var shareList = {
                        title: res.data.data.cName,
                        content: res.data.data.desc,
                    };
                    eventBus.$emit("shareList", shareList);
                }
            });
        },
        backGo(){
            const that = this;
            that.$router.push({
                path: "/lcDetail",
                query:{
                    cId:that.cId,
                }
            });
        },
    },
};
</script>